module.exports = __webpack_public_path__ + "contactBigCover.a402ffbadcc1a08af788.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/coverPicks/contactBigCover.jpg
// module id = ../../../../../src/assets/coverPicks/contactBigCover.jpg
// module chunks = 0